<div [hidden]="!(complete$ | async)">
  <form [formGroup]="group" class="questionsForm mt-2 mb-4">
    <div class="d-flex gap">
      <div>
        <div class="bold-label">Entered Mileage:</div>
        <app-number-input [group]="mileageControl"></app-number-input>
      </div>
      <div>
        <div class="bold-label">Mileage Decision:</div>
        <app-list-input [toggleDisabled]="toggleDisabledSubject.asObservable()" [group]="mileageDecisionControl" [options]="allowedDecisionOptions" 
          customClass="small-two-line" alert="true" class="popup-button">
        </app-list-input>
      </div>
    </div>
  </form>
  
  <div class="d-flex flex-row">
    <app-mot-history [provider]="'dvsa'" [mileageData]="dvsaMileage" [hasDiscrepancy]="hasDvsaDiscrepancy" [showMotHistory]="showDvsaHistory"></app-mot-history>
    <app-mot-history [provider]="'nmr'" [mileageData]="nmrMileage" [hasDiscrepancy]="hasNmrDiscrepancy" [showMotHistory]="showNmrHistory"></app-mot-history>
    <app-mot-history [provider]="'bca'" [mileageData]="bcaMileage" [hasDiscrepancy]="hasBcaDiscrepancy" [showMotHistory]="showBcaHistory"></app-mot-history>
  </div>
</div>
